<template>
  <div class="level-list-container">
    <el-row>
      <el-table
        :data="levelFinal"
        :show-header="false"
        :row-style="rowStyle"
        v-loading="loading"
        empty-text="無資料"
        style="width: 100%;">
        <el-table-column
          label="關卡"
          width="80">
          <template slot-scope="scope">
            <span class="level-title">總過關</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="名稱"
          width="150">
          <template slot-scope="scope">
            <span class="level-title">{{ scope.row | titleFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="role"
          label="introduction">
          <template slot-scope="scope">
            <span class="introduction-max-lines">{{ scope.row | introductionFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="count"
          label="點擊次數"
          width="80">
          <template slot-scope="scope">
            <div style="text-align: right">
              <span>點擊次數</span>
              <br>
              <span>{{ scope.row | tapCountFilter }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="count"
          label="過關次數"
          width="80">
          <template slot-scope="scope">
            <div style="text-align: right">
              <span>過關次數</span>
              <br>
              <span>{{ scope.row | passCountFilter }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="events"
          label="events"
          width="180">
          <template slot-scope="scope">
            <div
              class="beacon-events"
              :class="{ active: scope.row['beacons'] && scope.row['beacons'].length > 0 }"
              @click="handleBindingBeacon(scope.row)">
              <span class="tfam-link">{{ scope.row['beacons'] | filterBeaconNames }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-table
        :data="levelList"
        :show-header="false"
        :row-style="rowStyle"
        v-loading="loading"
        empty-text="無資料"
        style="width: 100%;">
        <el-table-column
          type="index"
          width="80">
        </el-table-column>
        <el-table-column
          prop="name"
          label="名稱"
          width="150">
          <template slot-scope="scope">
            <span class="level-title" @click="goLevel(scope.row['level_id'])">{{ scope.row | titleFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="role"
          label="introduction">
          <template slot-scope="scope">
            <span class="introduction-max-lines">{{ scope.row | introductionFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="count"
          label="點擊次數"
          width="80">
          <template slot-scope="scope">
            <div style="text-align: right">
              <span>點擊次數</span>
              <br>
              <span>{{ scope.row | tapCountFilter }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="count"
          label="過關次數"
          width="80">
          <template slot-scope="scope">
            <div style="text-align: right">
              <span>過關次數</span>
              <br>
              <span>{{ scope.row | passCountFilter }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="events"
          label="events"
          width="180">
          <template slot-scope="scope">
            <div
              class="beacon-events"
              :class="{ active: scope.row['beacons'] && scope.row['beacons'].length > 0 }"
              @click="handleBindingBeacon(scope.row)">
              <span class="tfam-link">{{ scope.row['beacons'] | filterBeaconNames }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!--
    <div class="create-new" @click="createNew()">
      <span class="tfam-new"></span>
    </div>
    -->
    <el-dialog
      title="選擇iBeacon"
      :visible.sync="beaconDialogVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :center="true">
      <beacon-select
        :binding-data="levelData"
        binding-type="level"
        @update="finishBeaconBinding"></beacon-select>
    </el-dialog>
  </div>
</template>

<script>
  import { fetchLevelList } from "../../api/level";
  import BeaconSelect from "../Componments/BeaconSelect";
  export default {
    name: "LevelList",
    components: {
      BeaconSelect
    },
    computed: {
      rowStyle: function () {
        return {
          height: '80px',
          cursor: 'default'
        }
      }
    },
    data() {
      return {
        levelList: [],
        levelFinal: [],
        loading: false,
        levelData: undefined,
        beaconDialogVisible: false,
      }
    },
    filters: {
      titleFilter: function (row) {
        const filter = row['levelLangs'].filter(x => x['language_key'] === 'ZH_TW');
        if (filter.length > 0) {
          return filter[0]['title'] ? filter[0]['title'] : '-'
        } else {
          return '-'
        }
      },
      introductionFilter: function (row) {
        const filter = row['levelLangs'].filter(x => x['language_key'] === 'ZH_TW');
        if (filter.length > 0) {
          return filter[0]['introduction'] ? filter[0]['introduction'] : '-'
        } else {
          return '-'
        }
      },
      filterBeaconNames: function (beacons) {
        if (beacons && beacons.length > 0) {
          const names = [];
          for (const i in beacons) {
            names.push(beacons[i]['title'])
          }
          return names.join('，')
        } else {
          return '未綁定'
        }
      },
      tapCountFilter: function (row) {
        let count = 0
        for (const i in row.levelLangs) {
          count += row.levelLangs[i]['tap_count']
        }
        return count
      },
      passCountFilter: function (row) {
        let count = 0
        for (const i in row.levelLangs) {
          count += row.levelLangs[i]['pass_count']
        }
        return count
      }
    },
    mounted() {
      this.getLevelList()
    },
    methods: {
      finishBeaconBinding(val) {
        this.beaconDialogVisible = false;
        this.levelData = undefined;
        if (val['reload']) {
          this.getLevelList()
        }
      },
      handleBindingBeacon(row) {
        this.levelData = JSON.parse(JSON.stringify(row));
        this.beaconDialogVisible = true;
      },
      getLevelList() {
        this.loading = true;
        const filter = {
          order: 'index_sort ASC',
          include: ['levelLangs', 'beacons']
        };
        fetchLevelList(filter).then(response => {
          this.loading = false;
          this.levelList = response.data.filter(x => x.index_sort > 0);
          this.levelFinal = response.data.filter(x => x.index_sort < 0);
        }).catch(err => {
          this.loading = false;
        })
      },
      goLevel(id) {
        this.$router.push({
          path: '/levels/' + id
        })
      },
      createNew() {
        this.goLevel('new')
      }
    }
  }
</script>

<style lang="scss">
  .introduction-max-lines {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    -webkit-box-orient: vertical;
  }
  .level-title {
    cursor: pointer;
  }
</style>
